<template>
  <div class="page-header header-filter section-image" filter-color="black">
    <!-- Optimized background image for mobile -->
    <div
      class="page-header-image"
      style="
        background-image: url('/img/ben-white-qDY9ahp0Mto-unsplash.jpg');
        background-size: cover;
        background-position: center;
      "
    ></div>
    <div class="content">
      <div class="container">
        <!-- Centered card using Now UI Kit's grid -->
        <div class="col-md-6 col-sm-12 mx-auto pt-5 pt-md-7">
          <notifications></notifications>
          <div>
            <h1 style="margin-top:1em;">Well, Look Who's Here!</h1>
          </div>
          <card type="login" plain>
            
            <div class="mb-2" role="status">{{ message }}</div>
            <div
              v-if="errorMessage.length > 0"
              class="alert alert-danger"
              role="alert"
            >
              {{ errorMessage }}
            </div>
            <form @submit.prevent="loginClick(username, password)">
              <!-- Email input with accessibility -->
              <div class="form-group">
                <label for="email" class="sr-only">Email Address</label>
                <fg-input
                  id="email"
                  class="no-border"
                  trim
                  :class="{ 'is-invalid': errors.email }"
                  addon-left-icon="now-ui-icons users_circle-08"
                  v-model="username"
                  type="email"
                  required
                  autocomplete="email"
                  placeholder="Email Address"
                ></fg-input>
                <div class="invalid-feedback">{{ errors.email }}</div>
              </div>

              <!-- Password input with accessibility -->
              <div class="form-group">
                <label for="password" class="sr-only">Password</label>
                <fg-input
                  id="password"
                  class="no-border"
                  :class="{ 'is-invalid': errors.password }"
                  addon-left-icon="now-ui-icons text_caps-small"
                  v-model="password"
                  type="password"
                  required
                  autocomplete="password"
                  placeholder="Password"
                ></fg-input>
                <div class="invalid-feedback">{{ errors.password }}</div>
              </div>

              <!-- Signup code input (conditional) -->
              <div class="form-group" v-if="askSignupCode">
                <label for="signupCode" class="sr-only">Registration Code</label>
                <fg-input
                  id="signupCode"
                  class="no-border"
                  trim
                  addon-left-icon="now-ui-icons users_circle-08"
                  v-model="signupCode"
                  type="text"
                  placeholder="Registration Code"
                ></fg-input>
              </div>

              <div class="card-footer text-center">
                <button
                  type="submit"
                  class="btn btn-primary btn-round btn-lg btn-block"
                  :disabled="loading"
                >
                  Log Me In!
                </button>
              </div>
              <router-link
                class="link show-hand forgot-password-link"
                :to="{ name: 'forgotpassword' }"
              >
                Forgot Password
              </router-link>
            </form>
          </card>
        </div>
     
      </div>
    </div>
    <main-footer></main-footer>
  </div>
</template>

<script>
import { Button, Card, FormGroupInput } from "@/components";
import constants from "@/constants";
import MainFooter from "@/layout/MainFooter";
import AuthenticationService from "@/services/AuthenticationService";

export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    Card,
    MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      title: constants.PORTAL_APIURL,
      errorMessage: "",
      askSignupCode: false,
      signupCode: "",
      loading: false,
      username: "",
      password: "",
      message: "Please Sign In",
      errors: { email: "", password: "" }, // Validation feedback
    };
  },
  methods: {
    async loginClick(userId, pass) {
      if (this.loading) return;
      this.loading = true;
      this.errors = { email: "", password: "" }; // Reset errors

      this.username = this.username.trim();
      this.signupCode = this.signupCode.trim();

      // Basic client-side validation
      if (!this.username) {
        this.errors.email = "Email is required";
        this.loading = false;
        return;
      }
      if (!pass) {
        this.errors.password = "Password is required";
        this.loading = false;
        return;
      }

      let creds = {
        email: this.username.toLowerCase(),
        password: pass,
        signupCode: this.signupCode,
      };

      if (this.askSignupCode && this.signupCode.length !== 7) {
        this.$notify({
          message: "Your registration code should be 7 characters, including the dash.",
          icon: "fa fa-exclamation",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger",
        });
        this.loading = false;
        return;
      }

      try {
        this.askSignupCode = false;
        const result = await AuthenticationService.login(creds);

        if (result.status === 200) {
          this.message = result.data.message;
          this.$root.login(result.data);
          this.$router.push({ name: "main" }); // Named route
          return;
        }

        this.$notify({
          message: result.data.message,
          icon: "fa fa-exclamation",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger",
        });
        this.errorMessage = result.data.message;
      } catch (err) {
        if (err.response?.data?.message) {
          if (err.response.data.unVerified) {
            this.$notify({
              message: "Check your email for the registration code and enter it here",
              icon: "fa fa-exclamation",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "info",
            });
            this.askSignupCode = true;
            this.message =
              "We sent your registration code to your email address. Please check your email and enter it in the required field";
          } else {
            this.$notify({
              message: err.response.data.message,
              icon: "fa fa-exclamation",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
            this.errorMessage = err.response.data.message;
          }
        } else {
          this.errorMessage = "An error occurred. Please try again.";
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
/* Fix input sizing for mobile */
.form-group .fg-input {
  width: 100%;
}
</style>